import './index.css';
import img from '../../../src/images/Filter.svg';
import img1 from '../../../src/images/Ai.svg';
import img2 from '../../../src/images/Profile.svg';
import img3 from '../../../src/images/hearticon.svg';
import img5 from '../../../src/images/flagicon.svg';
import img7 from '../../../src/images/plusicon.svg';
import img14 from '../../../src/images/patient-icon.svg'; // Patients Icon
import img15 from '../../../src/images/home2.svg'
import img16 from '../../../src/images/analyticsicon.svg'
import img17 from '../../../src/images/notification.svg'
import img18 from '../../../src/images/Calendar.svg'
import img19 from '../../../src/images/Icon (6).svg'
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import config from '../../config/config';

function AnalysisPage() {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const backendURL = `${config.backendServerHost}`;


    // Fetch data from the backend API
   useEffect(() => {
    // Fetch data from the backend API
    fetch(`${backendURL}/patients/api/analysis`) // Correct usage of template string with backticks
        .then((res) => res.json())
        .then((fetchedData) => {
            setData(fetchedData);
            setLoading(false);
        })
        .catch((error) => {
            console.error('Error fetching data:', error);
            setLoading(false);
        });
}, []);


const navigateTo = (path, state = {}) => {
  navigate(path, { state });
};


    const handleReviewClick = (patientId) => {
        alert(`Marked patient with ID ${patientId} as reviewed.`);
    };

    if (loading) {
        return <div>Loading...</div>;
    }

    if (!data) {
        return <div>Error loading data. Please try again later.</div>;
    }

    return (
        <div className="dashboard_container Analysis_container">
            <div className="navbar_container">
                <div>
                    <h1>Analysis & Reports</h1>
                </div>
                <div className="navbar_icon">
                    <div className="navbar_icon_img">
                        <img src={img} alt="" />
                    </div>
                    <div className="navbar_icon_img">
                        <img src={img1} alt="" />
                    </div>
                    <div style={{ cursor: 'pointer' }}>
                        <img src={img2} alt="" />
                    </div>
                </div>
            </div>
            <div className="navbar_bottom_line"></div>

            {/* Summary Cards */}
            <div className="summary">
                <div className="summary-card">
                    <div className="report_heading">
                        <div>
                            <img src={img3} alt="Heart Icon" />
                        </div>
                        <div>
                            <h3>Reports Summary</h3>
                        </div>
                    </div>
                    <p className='reviewed-text2'>Reports Reviewed</p>
                    <div className="progress-bar">
                        <div
                            className="progress"
                            style={{ width: `${data?.reportsSummary?.completionRate || 0}%` }}
                        ></div>
                    </div>
                    <p className='reviewed-text'>
                        {data?.reportsSummary?.reviewedReports || 0}/{data?.reportsSummary?.totalReports || 0} Reports reviewed
                        <span className="pending"> {data?.reportsSummary?.pendingReports || 0} Pending</span>
                    </p>
                </div>

                <div className="summary-card">
                    <div className="report_heading">
                        <div>
                            <img src={img5} alt="Flag Icon" />
                        </div>
                        <div>
                            <h3>AI Analysis Summary</h3>
                        </div>
                    </div>
                    <p className='reviewed-text2'>Analysis Complete</p>
                    <div className="progress-bar">
                        <div
                            className="progress"
                            style={{ width: `${data?.aiAnalysisSummary?.completionRate || 0}%` }}
                        ></div>
                    </div>
                    <p className='reviewed-text'>
                        {data?.aiAnalysisSummary?.completedAnalyses || 0}/{data?.aiAnalysisSummary?.totalAnalyses || 0} Analyses
                        <span className="pending"> {data?.aiAnalysisSummary?.pendingAnalyses || 0} Pending</span>
                    </p>
                </div>
            </div>

            <div className="add_button">
                <button>
                    <img src={img7} alt="Add Icon" />
                    <span>Add a patient</span>
                </button>
            </div>

            {/* Recent Reports Section */}
             <div className='analysis-heading'>
                <h1>Recent Reports & Analysis</h1>
            </div>



            <div className="recent-reports">
                {(data?.recentReports || []).map((report) => (
                    <div 
                    key={report.id} 
                    className="report-card" 
                    onClick={() => {
                        console.log('Navigating to PatientInfo with:', {
                            patientName: report.name,
                            patientAge: report.age,
                            patientCondition: report.condition,
                        });


                        navigateTo('/patientinfo', {
                            state: { 
                                patientName: report.name, 
                                patientAge: report.age, 
                                patientCondition: report.condition 
                            },
                        });
                    }}
                >
                    <h3>{report.name}</h3>
                    <p>Age: {report.age}</p>
                    <p>Condition: {report.condition}</p>
                    <div className="lab-results">
                            <p>Lab Results:</p>
                            HbA1c: {report.latestLabResults?.hba1c || "N/A"}
                            Blood Glucose: {report.latestLabResults?.bloodGlucose || "N/A"}
                            LDL Cholesterol: {report.latestLabResults?.ldlCholesterol || "N/A"}
                        </div>
                        <p>Risk Level: {report.riskLevel}</p>
                        <p>AI Analysis Insights: {report.aiAnalysisInsights}</p>
                        <p>Next Follow-Up: {report.nextFollowUp}</p>
                        <button
                            className="btn"
                            onClick={() => handleReviewClick(report.id)}
                            disabled={report.aiAnalysisInsights === "Reviewed by physician"}
                        >
                            {report.aiAnalysisInsights === "Reviewed by physician" ? "Reviewed" : "Review"}
                        </button>
                    </div>
                ))}
            </div>

             {/* Analysis Patients Section */}
             <div className='analysis-heading'>
                <h1>Patients for Analysis</h1>
            </div>

            <div className="analysis-patients">
                {(data?.analysisPatients || []).map((patient) => (
                    <div key={patient.id} className="patient-card">
                        <h3>{patient.name}</h3>
                        <p>Age: {patient.age}</p>
                        <p>Status: {patient.status}</p>
                    </div>
                ))}
            </div>


            <div className='footer_container_wrapper'>
                <div className='footer_container'>
                <div className='footer_icon' onClick={() => navigateTo('/dashboard-page')}>
                        <img src={img15} alt="Home Icon" />
                    </div>
                    {/* Analytics Icon: Navigates to AnalysisPage */}
                    <div className='footer_icon' onClick={() => navigateTo('/analysis')}>
                        <img src={img16} alt="Analytics Icon" />
                    </div>
                    <div className='footer_icon' onClick={() => navigateTo('/alerts')}>
                        <img src={img17} alt="Notification Icon" />
                    </div>
                    <div className='footer_icon' onClick={() => navigateTo('/appointments')}>
                        <img src={img18} alt="Calendar Icon" />
                    </div>
                    <div className="footer_icon" onClick={() => navigate('/Aianalysis1')}>
                        <img src={img14} alt="Patient Icon" />
                    </div>
                </div>
            </div>

        </div>
    );
}

export default AnalysisPage;

